import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { masterServiceBaseUrl } from "services/http";
import { endpoint } from "views/pages/manage/common/constant";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const fetchData = async (url, name) => {
  try {
    const resp = await fetchAllPromisedData(url, true);
    let data = [];
    if (resp?.code === 200) {
      data = resp.data
        ?.filter((el) => el.status === "ACTIVE")
        ?.map((el) => ({
          ...el,
          label: el[`${name}`],
          value: el[`${name}`],
        }));
    }
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const fetchLocationData = async () => {
  const dataArr = await Promise.all([
    // fetchData(`${masterServiceBaseUrl}/pincode/getAllPincode`, "pincodeGstCode"),
    fetchData(
      `${masterServiceBaseUrl}/district/getAllDistrict`,
      "districtDispValue"
    ),
    fetchData(`${masterServiceBaseUrl}/city/getAllCity`, "cityDispValue"),
    fetchData(`${masterServiceBaseUrl}/state/getAllState`, "stateDispValue"),
    fetchData(
      `${masterServiceBaseUrl}/country/getAllCountry`,
      "countryDispValue"
    ),
  ]);

  return {
    // pincodeData: dataArr[0],
    districtData: dataArr[0],
    cityData: dataArr[1],
    stateData: dataArr[2],
    countryData: dataArr[3],
  };
};

export const validatePincode = async (
  val,
  setBasicForm = () => {},
  dropdowns = {}
) => {
  try {
    if (!val || val.length != 6) {
      setBasicForm((prev) => ({
        ...prev,
        city: "",
        state: "",
        country: "",
        isValidPin: false,
      }));
      return false;
    }
    const data = await fetchAllPromisedData(
      `${endpoint?.pincode?.getPinCodeDetails}/${val}`,
      true
    );
    if (data?.code == 200) {
      const pincodeCodeDetails = data?.data;
      if (isObjEmpty(dropdowns)) return true;
      else {
        const { districtData, cityData, stateData, countryData } = dropdowns;
        setBasicForm((prev) => ({
          ...prev,
          district: districtData.find(
            (district) => district.id === pincodeCodeDetails?.districtId
          )?.value,
          city: cityData.find((city) => city.id === pincodeCodeDetails?.cityId)
            ?.value,
          state: stateData.find(
            (state) => state.id === pincodeCodeDetails?.stateId
          )?.value,
          country: countryData.find(
            (country) => country.id === pincodeCodeDetails?.countryId
          )?.value,
          isValidPin: true,
        }));
      }
    } else {
      return false;
    }
  } catch (err) {
    console.error(err);
  }
};
